import React from 'react'
import { connect } from 'react-redux'
import { API } from 'aws-amplify'
import { Button, Form, TextArea, Loader } from 'semantic-ui-react'
import get from 'lodash/get'
import omit from 'lodash/omit'

import actions from '../redux/actions'
import './Transcript.css'

class Transcript extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: false,
      transcript: null
    }
  }

  componentDidMount () {
    this.loadTranscript()
  }

  componentDidUpdate () {
    !this.state.transcript && !this.state.isLoading && this.loadTranscript()
  }

  loadTranscript = async () => {
    const { transcription } = this.props

    if (!transcription) return

    this.setState({ isLoading: true })

    const transcript = await API.get(
      'transcriptions',
      `/transcriptions/${transcription.transcriptionId}/transcript`
    )

    this.setState({ transcript, isLoading: false })
  }

  render () {
    const { isLoading, transcript } = this.state

    if (!this.state.transcript) {
      return <div style={{ textAlign: 'center' }}><Loader active inline /></div>
    }

    const truncatedText = get(
      transcript,
      'results.transcripts[0].transcript',
      ''
    ).substr(0, 5000)

    return (
      <div className='Transcript'>
        <div>
          <Button onClick={this.downloadText} primary>
            Download Text
          </Button>
          <Button onClick={this.downloadJson} secondary>
            Download JSON
          </Button>
        </div>
        <div style={{ marginTop: '1em' }}>
          <Form>
            <Form.Field>
              <label>Text Preview</label>
              <TextArea
                value={truncatedText}
                readOnly
                style={{ resize: 'none' }}
                rows={20}
              />
            </Form.Field>
          </Form>
        </div>
      </div>
    )
  }

  downloadText = () => {
    const { transcription } = this.props

    const fullText = get(
      this.state.transcript,
      'results.transcripts[0].transcript',
      ''
    )

    const element = document.createElement('a')
    const file = new Blob([fullText], { type: 'text/plain' })
    element.href = URL.createObjectURL(file)
    element.download = `${transcription.title}.txt`
    element.click()
  }

  downloadJson = () => {
    const { transcription } = this.props

    const jsonText = JSON.stringify(
      omit(this.state.transcript, ['accountId', 'jobName'])
    )

    const element = document.createElement('a')
    const file = new Blob([jsonText], { type: 'text/json' })
    element.href = URL.createObjectURL(file)
    element.download = `${transcription.title}.json`
    element.click()
  }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Transcript)



// WEBPACK FOOTER //
// ./src/containers/Transcript.js